<template>
  <ClientOnly>
    <Btn
      :size="size"
      :disabled="!isSupported"
      shape="round"
      :aria-label="ariaLabel"
      @click.prevent="startShare">
      <SvgIcon name="System/share-2-line" />
    </Btn>
    <template #fallback>
      <Btn
        :size="size"
        shape="round"
        :aria-label="ariaLabel"
        disabled>
        <SvgIcon name="System/share-2-line" />
      </Btn>
    </template>
  </ClientOnly>
</template>
<script setup lang="ts">
import { useShare } from '@vueuse/core'

const { share, isSupported } = useShare()
interface Props {
  title?: string | undefined
  url: string | undefined
  ariaLabel?: string | undefined
  size?: string
}
const props = withDefaults(defineProps<Props>(), {
  ariaLabel: undefined,
  size: 'large',
  title: undefined,
  url: undefined
})

const startShare = async () => {
  try {
    await share({
      title: props.title,
      url: props.url

    })
  } catch (e) {
    console.log(e)
  }
}
</script>
